<template>
  <div id="zoomid-editor">
    <router-view />
  </div>
</template>

<script>
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

export default {
  name: 'App',
};

</script>

<style>
@import './styles/index.css';

#zoomid-editor {
  min-height: 800px;
  padding: 0;
  width: 1170px;
  margin-bottom: 50px;
}
</style>
